export default __webpack_public_path__ + "static/nav4-bf042cd6be3ae83afbe935240ed2e806.jpg";